import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { LoginService } from '../services/login/login';
import { UserStateService } from '../services/user-state/user-state';
import { map, catchError, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const loginService = inject(LoginService);
  const userStateService = inject(UserStateService);
  const router = inject(Router);

  //Verify if user is loaded and skip the verification
  if (userStateService.isUserLoaded()) {
    return true;
  }

  // Otherwise, verify token with the backend (which checks the HttpOnly cookie)
  return loginService.verifyToken().pipe(
    map(response => {
      if (response.status === 'success' && response.user) {
        return true;
      } else {
        router.navigate(['/login']);
        return false;
      }
    }),
    catchError(() => {
      router.navigate(['/login']);
      return of(false);
    })
  );
};


